import script from "./AllNumbersTablesIntegration.vue?vue&type=script&setup=true&lang=js"
export * from "./AllNumbersTablesIntegration.vue?vue&type=script&setup=true&lang=js"

import "./AllNumbersTablesIntegration.vue?vue&type=style&index=0&id=b7118260&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b7118260"]])

export default __exports__